import storageBackup from './storageBackup'

type Nonpersistent<T> = T | undefined
type Persistent<T> = T | undefined

export const getStorages = (persist?: boolean): [Nonpersistent<Storage>, Persistent<Storage>] => (
    persist === undefined ? [sessionStorage, localStorage] : persist ? [undefined, localStorage] : [sessionStorage, undefined]
)

export const engine = {
    getItem: <T> (keyName: string): [Nonpersistent<T>, Persistent<T>] => {
        const storages = getStorages()

        const states: [Nonpersistent<T>, Persistent<T>] = [undefined, undefined]

        for (const [i, storage] of storages.entries()) {
            try {
                const serializedValue = storage?.getItem(keyName) ?? null
                states[i] = serializedValue === null ? undefined : JSON.parse(serializedValue)
            } catch {
                states[i] = undefined
            }
        }

        return states
    },
    removeItem: (keyName: string): void => {
        const storages = getStorages()

        for (const storage of storages) {
            try {
                storage?.removeItem(keyName)
            } catch {} // eslint-disable-line no-empty
        }

        storageBackup.notifyStorageChange()
    },
    setItem: <T> (keyName: string, keyValue: T, persist = false): void => {
        const storages = getStorages(persist)
        const storage = storages[persist ? 1 : 0]

        try {
            const serializedValue = JSON.stringify(keyValue)
            storage?.setItem(keyName, serializedValue)
        } catch {} // eslint-disable-line no-empty

        storageBackup.notifyStorageChange()
    },
}
